import React from 'react';

import { Paper } from '@material-ui/core';
import styled from 'styled-components';

import { mobileUpMediaQuery } from 'constants/helper';

import SectionHeader from './SectionHeader';

export default function CardWithHeader({
  height,
  headerRightContent,
  displayBorder,
  heading,
  children,
  className,
  padding,
  header,
}) {
  // TODO: define a fixed height for the header

  return (
    <StyledPaper height={height} className={className}>
      {header || <SectionHeader rightContent={headerRightContent} displayBorder={displayBorder} heading={heading} />}
      {padding ? <ContentPadding className="contentPadding">{children}</ContentPadding> : children}
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  position: relative;
  margin: 0;
  height: 100%;

  ${(props) => mobileUpMediaQuery(props.theme)} {
    // margin: 4px;
    height: ${(props) => props.height};
  }
`;

const ContentPadding = styled.div`
  padding: 0 ${(props) => props.theme.space.horizontal.normal} ${(props) => props.theme.space.vertical.normal}
    ${(props) => props.theme.space.horizontal.normal} !important;
`;

CardWithHeader.defaultProps = {
  height: '12vh',
  heading: '',
  padding: true,
};

export function ModularCardWithHeader({ children, className }) {
  return <StyledPaper className={className}>{children}</StyledPaper>;
}

ModularCardWithHeader.SectionHeader = SectionHeader;
